import { supabase } from '../config/supabase';

export interface MediaLiteracyQuestion {
  id: string;
  question: string;
  description: string | null;
  category: string;
  order_index: number;
}

export interface MediaLiteracyAttempt {
  id: string;
  user_id: string;
  started_at: string;
  completed_at: string | null;
  answers: Record<string, number>; // question_id -> rating (1-5)
}

class MediaLiteracyScanApi {
  /**
   * Get all media literacy scan questions
   */
  async getQuestions(): Promise<MediaLiteracyQuestion[]> {
    const { data, error } = await supabase
      .from('media_literacy_questions')
      .select('*')
      .order('order_index', { ascending: true });

    if (error) throw error;
    return data || [];
  }

  /**
   * Create a new scan attempt
   */
  async createAttempt(userId: string): Promise<MediaLiteracyAttempt> {
    const { data, error } = await supabase
      .from('media_literacy_attempts')
      .insert({
        user_id: userId,
        started_at: new Date().toISOString(),
        answers: {}
      })
      .select()
      .single();

    if (error) throw error;
    return data;
  }

  /**
   * Update scan attempt with answers
   */
  async updateAttempt(
    attemptId: string,
    answers: Record<string, number>
  ): Promise<MediaLiteracyAttempt> {
    const { data, error } = await supabase
      .from('media_literacy_attempts')
      .update({
        completed_at: new Date().toISOString(),
        answers
      })
      .eq('id', attemptId)
      .select()
      .single();

    if (error) throw error;
    return data;
  }

  /**
   * Get user's scan history
   */
  async getUserAttempts(userId: string): Promise<MediaLiteracyAttempt[]> {
    const { data, error } = await supabase
      .from('media_literacy_attempts')
      .select('*')
      .eq('user_id', userId)
      .order('started_at', { ascending: false });

    if (error) throw error;
    return data || [];
  }
}

export const mediaLiteracyScanApi = new MediaLiteracyScanApi();
